// extracted by mini-css-extract-plugin
module.exports = {"calculator-description":"calculator_calculator-description__camba","title":"calculator_title__35RtI","content":"calculator_content__231x4"};